var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"counter",class:{ '-reverse' : _vm.reverse, '-active': _vm.active },attrs:{"aria-live":"polite"},domProps:{"innerHTML":_vm._s(_vm.value + ' <span class=\'a11y-sr-only\'>' + _vm.trad + '</span>')}})}
var staticRenderFns = []

export { render, staticRenderFns }